import useIsMobile from '@/hooks/use-is-mobile';
import { Button, ButtonProps, IconLogout } from '@cmpsr/components';

export default function LogOutButton(props: ButtonProps) {
  const isMobile = useIsMobile();

  return (
    <Button
      role="button"
      aria-label="Log out"
      variant="link-accent"
      color="text-light"
      size="m"
      trailingIcon={<IconLogout />}
      {...props}
    >
      {!isMobile && 'Log out'}
    </Button>
  );
}
